import React from "react";
import Modal from "../Modal";
import "../../styleSheets/buttons.css";
import "../../styleSheets/confirmationModal.css";

type ConfirmationModalProps = {
    isOpen: boolean;
    title: string;
    message: React.ReactNode;
    primaryLabel: string;
    secondaryLabel?: string;
    onPrimary: () => void;
    onSecondary?: () => void;
    primaryButtonClassName?: string;
    secondaryButtonClassName?: string;
    primaryDisabled?: boolean;
    secondaryDisabled?: boolean;
};

function ConfirmationModal({
                               isOpen,
                               title,
                               message,
                               primaryLabel,
                               secondaryLabel,
                               onPrimary,
                               onSecondary,
                               primaryButtonClassName = "btn btn--orange btn--size-md",
                               secondaryButtonClassName = "btn btn--white btn--size-md",
                               primaryDisabled = false,
                               secondaryDisabled = false,
                           }: ConfirmationModalProps) {
    const showSecondaryAction = !!secondaryLabel && !!onSecondary;

    return (
        <Modal isOpen={isOpen} onClose={onSecondary} ariaLabel={title}>
            <div className="profile-modal">
                <div className="profile-modal__title">{title}</div>
                <p className="profile-modal__text">{message}</p>
                <div className="profile-modal__actions">
                    {showSecondaryAction ? (
                        <button
                            type="button"
                            className={secondaryButtonClassName}
                            onClick={onSecondary}
                            disabled={secondaryDisabled}
                        >
                            {secondaryLabel}
                        </button>
                    ) : null}
                    <button
                        type="button"
                        className={primaryButtonClassName}
                        onClick={onPrimary}
                        disabled={primaryDisabled}
                    >
                        {primaryLabel}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmationModal;
